<template>
  <div class="step-loader-overlay" v-if="visible">
    <div class="step-loader-card">
      <div class="dots-box">
        <span class="dot-item"></span>
        <span class="dot-item"></span>
        <span class="dot-item"></span>
      </div>
      <div class="text-loader">
        <div class="words">
          <span 
            class="word" 
            v-for="(step, index) in steps" 
            :key="index"
            :style="{ transform: `translateY(-${displayStep * 100}%)` }"
          >{{ step }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StepLoader",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    steps: {
      type: Array,
      default: () => ["加载中..."],
    },
    currentStep: {
      type: Number,
      default: 0,
    },
    minStepDuration: {
      type: Number,
      default: 800,
    },
  },
  data() {
    return {
      displayStep: 0,
      pendingStep: null,
      lastStepTime: 0,
      stepTimer: null,
    };
  },
  watch: {
    currentStep(newStep) {
      this.scheduleStepChange(newStep);
    },
    visible(val) {
      if (val) {
        this.displayStep = 0;
        this.pendingStep = null;
        this.lastStepTime = Date.now();
      } else {
        if (this.stepTimer) {
          clearTimeout(this.stepTimer);
          this.stepTimer = null;
        }
      }
    },
  },
  methods: {
    scheduleStepChange(newStep) {
      const now = Date.now();
      const elapsed = now - this.lastStepTime;
      const remaining = this.minStepDuration - elapsed;

      if (this.stepTimer) {
        clearTimeout(this.stepTimer);
        this.stepTimer = null;
      }

      if (remaining <= 0) {
        this.displayStep = newStep;
        this.lastStepTime = now;
      } else {
        this.pendingStep = newStep;
        this.stepTimer = setTimeout(() => {
          this.displayStep = this.pendingStep;
          this.lastStepTime = Date.now();
          this.pendingStep = null;
          this.stepTimer = null;
        }, remaining);
      }
    },
  },
  beforeDestroy() {
    if (this.stepTimer) {
      clearTimeout(this.stepTimer);
    }
  },
};
</script>

<style scoped>
.step-loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.step-loader-card {
  --bg-color: #222;
  background-color: var(--bg-color);
  padding: 20px 32px;
  border-radius: 8px;
}

.dots-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.dot-item {
  display: inline-block;
  height: 12px;
  width: 12px;
  margin-right: 8px;
  border-radius: 50%;
  background-color: #c4a0fa;
  animation: dot-pulse 1.5s infinite ease-in-out;
}

.dot-item:last-child {
  margin-right: 0;
}

.dot-item:nth-child(1) {
  animation-delay: -0.3s;
}

.dot-item:nth-child(2) {
  animation-delay: -0.1s;
}

.dot-item:nth-child(3) {
  animation-delay: 0.1s;
}

@keyframes dot-pulse {
  0% {
    transform: scale(0.8);
    background-color: #c4a0fa;
    box-shadow: 0 0 0 0 rgba(128, 40, 245, 0.5);
  }
  50% {
    transform: scale(1.2);
    background-color: #8028f5;
    box-shadow: 0 0 0 6px rgba(128, 40, 245, 0);
  }
  100% {
    transform: scale(0.8);
    background-color: #c4a0fa;
    box-shadow: 0 0 0 0 rgba(128, 40, 245, 0.5);
  }
}

.text-loader {
  font-size: 18px;
  box-sizing: content-box;
  height: 28px;
  display: flex;
  justify-content: center;
}

.words {
  overflow: hidden;
  position: relative;
}

.words::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    var(--bg-color) 0%,
    transparent 20%,
    transparent 80%,
    var(--bg-color) 100%
  );
  z-index: 20;
  pointer-events: none;
}

.word {
  display: block;
  height: 28px;
  line-height: 28px;
  padding: 0 4px;
  color: #8028f5;
  text-align: center;
  transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
</style>
